import dynamic from "next/dynamic";
import Image from "next/image";
import { useMaterialUIController } from "/context";
const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });

export default function DialogPictureDisplay({ array, keyPrefix, viewMode }) {
  const [controller] = useMaterialUIController();
  return (
    <MDBox position="relative" zIndex={10} px={{ xs: 0, sm: 0 }}>
      <Grid container spacing={3} justifyContent="center">
        {array.map((row, index) => (
          <Grid item xs={12} md={6} lg={viewMode} key={`${keyPrefix}-${row.url}`}>
            {(controller.mobileView || (!controller.mobileView && viewMode === 12)) && (
              <MDBox sx={{ position: "relative" }}>
                <Image
                  src={row.url}
                  alt={row.alt}
                  width={0}
                  height={0}
                  sizes="24vw"
                  priority={index <= 1 ? true : false}
                  style={{ objectFit: "cover", width: '100%', height: 'auto' }}
                />
              </MDBox>
            )}
            {!controller.mobileView && viewMode === 6 && (
              <MDBox sx={{ position: "relative" }}>
                <Image
                  src={row.url}
                  alt={row.alt}
                  width={0}
                  height={0}
                  sizes="48vw"
                  priority={index <= 4 ? true : false}
                  style={{ objectFit: "cover", width: '100%', height: 'auto' }}
                />
              </MDBox>
            )}
            {!controller.mobileView && viewMode === 4 && (
              <MDBox sx={{ position: "relative" }}>
                <Image
                  src={row.url}
                  alt={row.alt}
                  width={0}
                  height={0}
                  sizes="96vw"
                  priority={index <= 6 ? true : false}
                  style={{ objectFit: "cover", width: '100%', height: 'auto' }}
                />
              </MDBox>
            )}
          </Grid>
        ))}
      </Grid>
    </MDBox>
  )
}